import { createAsyncThunk } from '@reduxjs/toolkit'
import { getPerpPositions, PerpPositionRecord } from '../../../api/v1/perp'

export const getPerpPositionsAction = createAsyncThunk<PerpPositionRecord[]>(
  'perp/getPerpPositionsAction',
  async () => {
    const r = await getPerpPositions(0)
    return r.data.results
  }
)
